import { render, staticRenderFns } from "./TotalImport.vue?vue&type=template&id=ac8fd766"
import script from "./TotalImport.vue?vue&type=script&lang=js"
export * from "./TotalImport.vue?vue&type=script&lang=js"
import style0 from "./TotalImport.vue?vue&type=style&index=0&id=ac8fd766&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports